<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="申领限额单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申领限额单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="创建人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>创建人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="deptName" label="科室" v-if="getIsView()">
                <el-select v-model="form.deptName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getDepts" @change="deptChange" style="width:100%">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>科室:{{ form.deptName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierProductNo" label="供应商产品编码" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.supplierProductNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>供应商产品编码:{{ form.supplierProductNo }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="productName" label="产品名称" v-if="getIsView()">
                <!-- :dataList="STATIC_SupplierProducts" -->
                <!-- <SelectTable :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'" :innerName="form.productName" :dataList="STATIC_SupplierProducts" @querySubmit="getProductList" @change="productChange" :filterable="false" :filterOptions="supplierProductFilterOptions" /> -->
                <SelectScrollTable :disabled="!editMode" :columns="limitApplySupplierProductColumns" :placeholder="'请选择产品'" :innerName="form.productName" :filterMethod="GetSupplierProducts" :otherQuery="supplierProductQuery" @change="productChange" />
              </el-form-item>
              <span class="viewText" v-else>产品名称:{{ form.productName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="specName" label="规格型号" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.specName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>规格型号:{{ form.specName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="manufacturerName" label="生产厂家" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.manufacturerName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>生产厂家:{{ form.manufacturerName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="minUnit" label="单位" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.minUnit"></el-input>
              </el-form-item>
              <span class="viewText" v-else>单位:{{ form.minUnit }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="packSpec" label="包装规格" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.packSpec"></el-input>
              </el-form-item>
              <span class="viewText" v-else>包装规格:{{ form.packSpec }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="number" label="限额数量" v-if="getIsView()">
                <el-input-number :disabled="!editMode" v-model="form.number" :min="1" :precision="0" ref="number" :controls="false" placeholder="请填写数量" @change="numberChange" style="width: 100%"></el-input-number>
              </el-form-item>
              <span class="viewText" v-else>限额数量:{{ form.number }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="applyedNumber" label="已申领数量" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.applyedNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else>已申领数量:{{ form.applyedNumber }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="otherNumber" label="限额可领数量" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.otherNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else>限额可领数量:{{ form.otherNumber }} </span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="startDate" label="开始时间" v-if="getIsView()">
                <el-date-picker :disabled="!editMode" v-model="form.startDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="开始时间" style="width:100%" @change="dateChange"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>开始时间:{{ form.startDate }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="endDate" label="结束时间" v-if="getIsView()">
                <el-date-picker :disabled="!editMode" v-model="form.endDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="结束时间" style="width:100%" @change="dateChange"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>结束时间:{{ form.endDate }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.supplierName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>供应商:{{ form.supplierName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="是否启用" prop="state" v-if="getIsView()">
                <el-switch :disabled="!editMode" v-model="form.state" @change="stateChange" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0" />
              </el-form-item>
              <span class="viewText" v-else>是否启用:{{ form.state }} </span>
            </el-col>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码" v-if="getIsView()">
                <el-input disabled v-model="form.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>医保代码:{{ form.medicalInsuranceCategoryNo }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="updateUserName" label="最后修改人" v-if="getIsView()">
                <el-input disabled placeholder="" v-model="form.updateUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>最后修改人:{{ form.updateUserName }} </span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="updateTime" label="最后修改时间" v-if="getIsView()">
                <el-date-picker v-model="form.updateTime" disabled type="datetime" placeholder="" style="width: 100%" />
              </el-form-item>
              <span class="viewText" v-else>最后修改时间:{{ form.updateTime }} </span>
            </el-col>

          </el-row>

        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import InStockScan from '@/mixin/inStockScan-mixin'
import {

  SaveLimitApply,
  RejectLimitApply,
  GetLimitApplyById,
  GetApplyedNumber
} from "@/api";
// import SelectTable from "@/components/select-table";
import SelectScrollTable from "@/components/select-scroll-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, InStockScan],
  components: {
    // SelectTable,
    SelectScrollTable,
    ApproveInfo,
  },
  data () {
    return {
      GetDataAction: GetLimitApplyById,
      SaveDataAction: SaveLimitApply,
      reject: RejectLimitApply,
      form: {},
      rules: {
        deptName: [
          { required: true, message: '请选择科室', trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '请选择产品名称', trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: '请选择结束时间', trigger: 'blur' },
          { validator: this.validateDate, trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请选择开始时间', trigger: 'blur' },
          { validator: this.validateDate, trigger: 'blur' }
        ]
      },

      editMode: false,
      showWorkFlowInfo: false,

    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getDepts('')
    this.getProductList({})
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.form.otherNumber = this.form.number - this.form.applyedNumber < 0 ? 0 : this.form.number - this.form.applyedNumber

        this.initWorkFlowProperty(this.form);

      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        no: '',
        deptId: this.userInfo.deptId,
        deptName: this.userInfo.deptName,
        supplierProductId: '',
        supplierProductNo: '',
        productId: '',
        productName: '',
        specId: '',
        specName: '',
        manufacturerId: '',
        manufacturerName: '',
        supplierId: '',
        supplierName: '',
        minUnit: '',
        packSpec: '',
        number: 0,
        applyedNumber: 0,
        otherNumber: 0,
        state: 1,
        remark: '',
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        startDate: this.parseTime(new Date(), "{y}-{m}-{d}"),
        endDate: '',
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },


    // change event
    productChange (row) {
      let id = this.form.id
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      this.form = Object.assign(this.form, row)// this.mapper.SupplierProduct2Form(this.form, arr[0])
      this.form.id = id
      this.form.supplierProductId = row.id
      this.form.supplierProductNo = row.no
      this.form.remark = ''

      this.getApplyedNumber()

      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.form.validateField('productName')
    },
    deptChange (val) {
      this.form.deptId = val

      this.getApplyedNumber()
    },
    numberChange () {
      this.form.otherNumber = this.form.number - this.form.applyedNumber < 0 ? 0 : this.form.number - this.form.applyedNumber
      // this.form.applyedNumber = 0
    },
    dateChange () {
      // this.form.applyedNumber = 0
      // this.form.otherNumber = this.form.number

      this.getApplyedNumber()
    },
    stateChange () {
      if (this.form.state == 0) {
        this.form.applyedNumber = ''
      }
      if (this.form.state == 1) {
        this.form.applyedNumber = 0
        this.getApplyedNumber()
      }
      this.form.otherNumber = this.form.number

    },

    getApplyedNumber () {
      let query = {
        deptId: this.form.deptId,
        supplierProductId: this.form.supplierProductId,
        startDate: this.form.startDate,
        endDate: this.form.endDate
      }
      GetApplyedNumber(query)
        .then(res => {
          this.form.applyedNumber = res.returnData
          this.form.otherNumber = this.form.number - this.form.applyedNumber < 0 ? 0 : this.form.number - this.form.applyedNumber
        })
    },



    getProductList (query) {
      query.isEnabled = 1
      query.status = 2
      query.pageIndex = 1
      query.pageSize = 50
      this.getSupplierProducts(query)
      //   {
      //   keyWord: keyWord, pageIndex: 1, pageSize: 100, isEnabled: 1,
      //   status: 2
      // })
    },

    validateDate (rule, value, callback) {
      if (this.form.startDate && this.form.endDate) {

        var endDate = new Date(this.form.endDate)
        var startDate = new Date(this.form.startDate)

        if (startDate > endDate) {
          callback(new Error('开始时间不能大于结束时间'))
        }

        // if (this.childForm.number >= 0 && validityDate < new Date()) {
        //   callback(new Error('有效期不能小于今天'))
        // }
        callback()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
